<template>
    <VideoPlayer class="video-general-cloudfront" v-bind="{sources, poster: overridePoster ?? posterURL}"></VideoPlayer>
</template>

<script>
export default {
    name: 'VideoGeneralCloudfront',
    data () {
        return {
            player: null,
            posterURL: null,
        };
    },
    props: {
        src: {
            required: true,
            type: String,
        },
        overridePoster: {
            required: false,
            type: String,
        }
    },
    computed: {
        sources () {
            return this.$videoUtilities.getCloudfrontVideoSources(this.src);
        },
    },
    methods: {
        async getPoster () {
            const {posterURL, error} = await useEntityUpload().getVideoPoster(this.src);
            this.posterURL = posterURL;
            if (error) console.error('Error getting video poster from the API: ' + error);
        },
    },
    mounted: function () {
        this.getPoster();
    },
};

</script>
